import * as React from 'react';
import PropTypes from 'prop-types';
import ButtonBase from '@material-ui/core/ButtonBase';
import classnames from 'classnames';

const propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  select: PropTypes.bool,
};

const defaultProps = {
  onClick: null,
  children: null,
  select: false,
};

function ChannelTab(props) {
  const { onClick, children, select } = props;
  // if (children === 'VOD') {
  //   return (
  //     <ButtonBase
  //       // onClick={onClick}
  //       classes={{ root: classnames('tab-item', 'none') }}
  //     >
  //       {children}
  //     </ButtonBase>
  //   )
  // }
  return (
    <ButtonBase
      onClick={onClick}
      classes={{ root: classnames('tab-item', { select }) }}
    >
      {children}
    </ButtonBase>
  );
}

ChannelTab.propTypes = propTypes;
ChannelTab.defaultProps = defaultProps;

export default ChannelTab;
